import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      children: [
             {
               name: 'Login',
               path: 'login',
               component: () => import('@/views/pages/Login'),
               meta: {
                 notRequiresAuth: true,
              },
             },
      ],
    },
    {
       name: 'index',
       path: '/',
       component: () => import('@/views/dashboard/Index'),
       meta: {
         roles: ['Admin'],
        notRequiresAuth: false,
      },
       children: [

        {
          name: 'products',
          path: 'products/list',
          component: () => import('@/views/dashboard/products/ProductList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'product',
          path: 'products/view/:id',
          component: () => import('@/views/dashboard/products/Product'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'productCategories',
          path: 'productCategories/list',
          component: () => import('@/views/dashboard/productCategories/ProductCategoryList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'productCategory',
          path: 'productCategories/view/:id',
          component: () => import('@/views/dashboard/productCategories/ProductCategory'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'productSubCategories',
          path: 'productSubCategories/list',
          component: () => import('@/views/dashboard/productSubCategories/ProductSubCategoryList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'productSubCategory',
          path: 'productSubCategories/view/:id',
          component: () => import('@/views/dashboard/productSubCategories/ProductSubCategory'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'sections',
          path: 'sections/list',
          component: () => import('@/views/dashboard/sections/SectionList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'section',
          path: 'sections/view/:id',
          component: () => import('@/views/dashboard/sections/Section'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'gameLines',
          path: 'gameLines/list',
          component: () => import('@/views/dashboard/gameLines/GameLineList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'gameLine',
          path: 'gameLine/view/:id',
          component: () => import('@/views/dashboard/gameLines/GameLine'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'gameRarities',
          path: 'gameRarities/list',
          component: () => import('@/views/dashboard/gameRarities/GameRarityList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'gameRarity',
          path: 'gameRarities/view/:id',
          component: () => import('@/views/dashboard/gameRarities/GameRarity'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'cards',
          path: 'cards/list',
          component: () => import('@/views/dashboard/cards/CardList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'card',
          path: 'cards/view/:id',
          component: () => import('@/views/dashboard/cards/Card'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'customers',
          path: 'customers/list',
          component: () => import('@/views/dashboard/customers/CustomerList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orders',
          path: 'orders/list',
          component: () => import('@/views/dashboard/orders/OrderList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'order',
          path: 'orders/view/:id',
          component: () => import('@/views/dashboard/orders/Order'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'preOrders',
          path: 'preOrders/list',
          component: () => import('@/views/dashboard/preOrders/PreOrderList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'preOrder',
          path: 'preOrders/view/:id',
          component: () => import('@/views/dashboard/preOrders/PreOrder'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'quotations',
          path: 'quotations/list',
          component: () => import('@/views/dashboard/quotations/QuotationList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'quotation',
          path: 'quotations/view/:id',
          component: () => import('@/views/dashboard/quotations/Quotation'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'shippingTypes',
          path: 'shippingTypes/list',
          component: () => import('@/views/dashboard/shippingTypes/ShippingTypeList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'shippingType',
          path: 'shippingTypes/view/:id',
          component: () => import('@/views/dashboard/shippingTypes/ShippingType'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'sliderImages',
          path: 'sliderImages/list',
          component: () => import('@/views/dashboard/sliderImages/SliderImageList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'sliderImage',
          path: 'sliderImages/view/:id',
          component: () => import('@/views/dashboard/sliderImages/SliderImage'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'bankAccounts',
          path: 'bankAccounts/list',
          component: () => import('@/views/dashboard/bankAccounts/BankAccountList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'bankAccount',
          path: 'bankAccounts/view/:id',
          component: () => import('@/views/dashboard/bankAccounts/BankAccount'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderValidates',
          path: 'orderValidates/list',
          component: () => import('@/views/dashboard/orderValidates/OrderValidateList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderValidate',
          path: 'orderValidates/view/:id',
          component: () => import('@/views/dashboard/orderValidates/OrderValidate'),
          meta: {
             roles: ['Admin'],
          },
        },
        // {
        //   name: 'orderHistories',
        //   path: 'orderHistories/list',
        //   component: () => import('@/views/dashboard/orderHistories/OrderHistoryList'),
        //   meta: {
        //      roles: ['Admin'],
        //   },
        // },
        // {
        //   name: 'orderValidate',
        //   path: 'orderHistories/view/:id',
        //   component: () => import('@/views/dashboard/orderHistories/OrderHistory'),
        //   meta: {
        //      roles: ['Admin'],
        //   },
        // },
        // ###################### NEW #######################################
        {
          name: 'company',
          path: 'company/view',
          component: () => import('@/views/dashboard/company/Company'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'invoiceParameter',
          path: 'invoiceParameter/view',
          component: () => import('@/views/dashboard/invoiceParameter/InvoiceParameter'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderProcesses',
          path: 'orderProcess/list',
          component: () => import('@/views/dashboard/orderProcess/OrderProcessList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderProcess',
          path: 'orderProcess/view/:id',
          component: () => import('@/views/dashboard/orderProcess/OrderProcess'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderDelivers',
          path: 'orderDeliver/list',
          component: () => import('@/views/dashboard/orderDeliver/OrderDeliverList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderDeliver',
          path: 'orderDeliver/view/:id',
          component: () => import('@/views/dashboard/orderDeliver/OrderDeliver'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderCancels',
          path: 'orderCancel/list',
          component: () => import('@/views/dashboard/orderCancel/OrderCancelList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderCancel',
          path: 'orderCancel/view/:id',
          component: () => import('@/views/dashboard/orderCancel/OrderCancel'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderRevokes',
          path: 'orderRevoke/list',
          component: () => import('@/views/dashboard/orderRevoke/OrderRevokeList'),
          meta: {
             roles: ['Admin'],
          },
        },
        {
          name: 'orderRevoke',
          path: 'orderRevoke/view/:id',
          component: () => import('@/views/dashboard/orderRevoke/OrderRevoke'),
          meta: {
             roles: ['Admin'],
          },
        },
        // #############################################################
        // {
        //   name: 'customer',
        //   path: 'customers/view/:id',
        //   component: () => import('@/views/dashboard/cards/Customer'),
        //   meta: {
        //      roles: ['Admin'],
        //   },
        // },
        {
          name: 'shop',
          path: 'shops/view/:id',
          component: () => import('@/views/dashboard/shops/Shop'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'machines',
          path: 'machines/list',
          component: () => import('@/views/dashboard/machines/MachineList'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'machine',
          path: 'machines/view/:id',
          component: () => import('@/views/dashboard/machines/Machine'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'shopVisits',
          path: 'shops/shopVisits/:id',
          component: () => import('@/views/dashboard/shopMachineVisits/ShopMachineVisitList'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'routers',
          path: 'routers/list',
          component: () => import('@/views/dashboard/routers/RouterList'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'router',
          path: 'routers/view/:id',
          component: () => import('@/views/dashboard/routers/Router'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'courierGroups',
          path: 'courierGroups/list',
          component: () => import('@/views/dashboard/courierGroups/CourierGroupList'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'courierGroup',
          path: 'courierGroup/view/:id',
          component: () => import('@/views/dashboard/courierGroups/CourierGroup'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
        name: 'users',
          path: 'users/list',
          component: () => import('@/views/dashboard/users/UserList'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'user',
          path: 'user/view/:id',
          component: () => import('@/views/dashboard/users/User'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'cashDesks',
            path: 'cashDesks/list',
            component: () => import('@/views/dashboard/cashDesk/CashDeskList'),
            meta: {
              roles: ['Admin'],
            },
        },
        {
          name: 'cashDesk',
          path: 'cashDesk/view/:id',
          component: () => import('@/views/dashboard/cashDesk/CashDesk'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'cashDeskMovements',
          path: 'cashDesk/movements',
          component: () => import('@/views/dashboard/cashDeskMovements/CashDeskMovementList'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'incomeCategories',
            path: 'incomeCategories/list',
            component: () => import('@/views/dashboard/categories/IncomeCategoryList'),
            meta: {
              roles: ['Admin'],
            },
        },
        {
          name: 'incomeCategory',
          path: 'incomeCategory/view/:id',
          component: () => import('@/views/dashboard/categories/IncomeCategory'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'expenseCategories',
          path: 'expenseCategories/list',
          component: () => import('@/views/dashboard/categories/ExpenseCategoryList'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'expenseCategory',
          path: 'expenseCategory/view/:id',
          component: () => import('@/views/dashboard/categories/ExpenseCategory'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'expenses',
          path: 'expenses/list',
          component: () => import('@/views/dashboard/expenses/ExpenseList'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'expenseRegister',
          path: 'expenseRegister/:id',
          component: () => import('@/views/dashboard/expenses/ExpenseRegister'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'incomes',
          path: 'incomes/list',
          component: () => import('@/views/dashboard/incomes/IncomeList'),
          meta: {
            roles: ['Admin'],
          },
        },
        {
          name: 'incomeRegister',
          path: 'incomeRegister/:id',
          component: () => import('@/views/dashboard/incomes/IncomeRegister'),
          meta: {
            roles: ['Admin'],
          },
        },
    ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
          meta: {
            notRequiresAuth: true,
          },
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  const user = store.state.user
  if (to.matched.some(record => record.meta.notRequiresAuth)) {
    return next()
  }

  if (store.getters.isLoggedIn) {
    if (!user.roles) {
      next()
      return
    } else {
      const roles = to.meta.roles

      for (var i = 0; i < roles.length; i++) {
        for (var j = 0; j < user.roles.length; j++) {
          if (roles[i] === user.roles[j].name) {
            next()
            return
          }
        }
      }
      return next({
        path: '/pages/login',
        query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
      })
    }
  }
  next('/pages/login')
  // next('/dashboard/index')
  // next({
  //     path: '/page/login',
  //     query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
  //   })
})

export default router
